exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f172a2e0] .el-table{background:hsla(0,0%,100%,.3803921568627451)!important}[data-v-f172a2e0] .el-table thead th{padding:0;background:none!important}[data-v-f172a2e0] .el-table__body-wrapper{background:none!important;height:calc(100% - 25px);overflow-y:scroll}[data-v-f172a2e0] .el-table__empty-block{background:none!important}[data-v-f172a2e0] .el-table__expanded-cell{background:hsla(0,0%,100%,.25098039215686274)!important;padding:0 10px;padding-left:20px}", ""]);

// exports
